import { render, staticRenderFns } from "./ToolTypeFilesEditDialog.vue?vue&type=template&id=215c3f85&"
import script from "./ToolTypeFilesEditDialog.vue?vue&type=script&lang=ts&"
export * from "./ToolTypeFilesEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ToolTypeFilesEditDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VCard,VDialog,VIcon})
